export default "__VITE_ASSET__0446b0f0__"